import { ApiSupplierAccessRecord, ApiWarehouseSupplier } from '@kaiizen/kai-pro-api';

export const getDefaultRecord = (records: ApiSupplierAccessRecord[], supplierId: string) =>
  records.find(row => row.supplierId === supplierId && row.scope === 'default');

export const getOrgRecords = (records: ApiSupplierAccessRecord[], supplierId: string) =>
  records.filter(row => row.supplierId === supplierId && row.scope === 'org');

export const describeDefault = (record: ApiSupplierAccessRecord | undefined) =>
  !record ? 'Off (no default)' : record.enabled ? 'On for every org' : 'Off for every org';

export const describeOrgSetting = (record: ApiSupplierAccessRecord) => (record.enabled ? 'Enabled' : 'Disabled');

export const describeSupplierMeta = ({ slug, hasCatalog, active }: ApiWarehouseSupplier) =>
  `(${[slug, !hasCatalog && 'no catalog', !active && 'inactive'].filter(Boolean).join(', ')})`;

/** The dialog an org's row opens: switch its setting, or reset it so the supplier's default decides. */
export const buildOrgSettingDialog = (
  supplierName: string,
  orgName: string,
  orgRecord: ApiSupplierAccessRecord,
  defaultRecord: ApiSupplierAccessRecord | undefined,
) => ({
  title: `${supplierName} for ${orgName}`,
  message: `${supplierName} is ${orgRecord.enabled ? 'enabled' : 'disabled'} for ${orgName}. Reset to default turns it ${
    defaultRecord?.enabled ? 'on' : 'off'
  }, following the default.`,
  toggleLabel: orgRecord.enabled ? 'Disable' : 'Enable',
});
